module.exports = __webpack_public_path__ + "img/SketchPng32bccd98d48e88de7ccaf8b92dafdb65eee7896c2f624f1e881a20ef825b7aa0.28a51c36.png";